// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-content {
  font-size: 20px;
  color: #fff;
  position: relative;
}
.heroImage {
  width: 100%;
}
.about-section {
  padding: 80px 0px 40px;
}
.offer-section {
  padding: 40px 0px 80px;
}
.offer-list {
  padding-left: 18px;
}
.offer-list li {
  padding-bottom: 15px;
}
.offer-title {
  margin: 0px 0px 2px;
}
.cta-section {
  padding: 80px 0px;
  text-align: center;
  background-color: #dbdbdb;
}
.cta-section .sub-text {
  font-size: 20px;
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/general/about/About.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".sub-content {\n  font-size: 20px;\n  color: #fff;\n  position: relative;\n}\n.heroImage {\n  width: 100%;\n}\n.about-section {\n  padding: 80px 0px 40px;\n}\n.offer-section {\n  padding: 40px 0px 80px;\n}\n.offer-list {\n  padding-left: 18px;\n}\n.offer-list li {\n  padding-bottom: 15px;\n}\n.offer-title {\n  margin: 0px 0px 2px;\n}\n.cta-section {\n  padding: 80px 0px;\n  text-align: center;\n  background-color: #dbdbdb;\n}\n.cta-section .sub-text {\n  font-size: 20px;\n  margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
